import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { postCardPremium } from '../Post.css';

interface Props {
  text: string;
  style?: CSSProperties;
  isBadge?: boolean;
  hasIcon?: boolean;
  hasText?: boolean;
  className?: string;
}

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3">
    <path
      fillRule="evenodd"
      d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
      clipRule="evenodd"
    />
  </svg>
);

const ALIGN_OPTIONS: Record<string, string> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const Premium = ({ text, style, isBadge, hasIcon, hasText, className }: Props) => {
  return (
    <div className={classNames('flex', ALIGN_OPTIONS[style?.textAlign || 'left'])}>
      <span
        className={classNames(
          'whitespace-nowrap text-xs w-fit',
          'flex items-center gap-1',
          style?.textTransform || 'normal-case',
          isBadge && hasText && hasIcon && 'rounded-md px-2 py-1',
          isBadge && hasText && !hasIcon && 'rounded-md px-2 py-1',
          isBadge && !hasText && hasIcon && 'rounded-md p-2',
          postCardPremium,
          className,
        )}
      >
        {hasIcon && <LockIcon />}
        {hasText && <>{text}</>}
      </span>
    </div>
  );
};

export default Premium;
